import styled from "@emotion/styled";

import BaseButton from "./BaseButton";

const GhostButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  color: rgba(255, 255, 255, 0.96);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  outline: none;

  &:not(:disabled) {
    &:hover,
    &:focus-visible {
      color: #ffffff;
    }
  }
`;

export default GhostButton;
